// Module
var code = `<h2 data-bind="label:'cc_success_Saved_Request'">Your request has been successfully saved.</h2>
<p data-bind="label:'cc_success_Saved_Request_additional1'">We have assigned you the following ticket number
    <strong data-bind="text: request_id"></strong>
</p>
<p data-bind="label:'cc_success_Saved_Request_additional2'">Remember that you can track this ticket from the "My tickets" section of this customer website</p>
<p data-bind="label:'cc_success_Saved_Request_additional3'">We have sent you an email with this ticket number and we will keep you informed of the progress in the procedures.</p>`;
// Exports
module.exports = code;